export const getAbortController = (): AbortController => {
  return new AbortController();
};
